<div
    class="relative grow overflow-y-auto"
    [ngClass]="{ 'blur-[2px] pointer-events-none [&_*]:select-none': loading() }"
>
    @if (loading()) {
        <div
            class="absolute flex left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 justify-center items-center z-50"
        >
            <mat-spinner [diameter]="32"></mat-spinner>
        </div>
    }

    @if (category.error()) {
        <div class="p-4 text-red-500">Kategorija nije pronađena.</div>
    }

    @if (loaded()) {
        <div class="flex flex-col gap-4 bg-valamargray border-2 static p-4">
            <button class="flex valben-button text-lg ml-auto" (click)="save()">Spremi</button>

            <valben-dictionary-input
                [formField]="categoryForm.names"
                title="Naziv"
            ></valben-dictionary-input>

            <valben-boolean-input
                [formField]="categoryForm.isActive"
                title="Aktivan"
            ></valben-boolean-input>

            <valben-boolean-input
                [formField]="categoryForm.isDraft"
                title="Skica"
            ></valben-boolean-input>

            <div
                class="flex px-10 py-4 border-2 rounded-md gap-2 items-center"
                [ngClass]="categoryForm.type().invalid() ? 'border-red-500' : 'border-gray-900/10'"
            >
                <div class="text-lg font-semibold my-1">Tip</div>
                <mat-form-field subscriptSizing="dynamic" class="w-52">
                    <mat-select [value]="categoryForm.type().value()" (selectionChange)="setType($event.value)">
                        @for (opt of typeOptions; track opt.value) {
                            <mat-option [value]="opt.value">{{ opt.display }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>

            <div
                class="flex px-10 py-4 border-2 rounded-md gap-2 items-center"
                [ngClass]="categoryForm.parentId().invalid() ? 'border-red-500' : 'border-gray-900/10'"
            >
                <div class="text-lg font-semibold my-1">Parent kategorija</div>
                <mat-form-field subscriptSizing="dynamic" class="w-52">
                    <mat-select
                        [value]="categoryForm.parentId().value()"
                        (selectionChange)="categoryForm.parentId().value.set($event.value)"
                    >
                        @for (opt of parentOptions(); track opt.masterId) {
                            <mat-option [value]="opt.masterId">{{ opt.name }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="flex gap-4 justify-end items-center select-none">
                <button class="valben-button text-lg" (click)="back()">Natrag</button>
                <button class="valben-button text-lg" (click)="showDeleteModal()">Obriši</button>
                <button class="valben-button text-lg" (click)="save()">Spremi</button>
            </div>
        </div>
    }
</div>
